import { type OptionType } from '@hivebrite/design-system/Inputs';

import { type CategoryItem } from 'hb-react/backoffice/components/CategoriesList/types';

export const categoriesToOptions = (categories: Array<CategoryItem>) =>
  categories.map<OptionType>((category) => ({
    value: category.id,
    label: category.name,
  }));
